module.exports = __webpack_public_path__ + "static/img/other_info.f61c83ce.png";